import axios from 'axios'
import { CDN } from '../cdn/cdn'

const smwProxyInstance = axios.create({
  baseURL: `${CDN.getCdnUrl()}proxy`,
  timeout: 20_000
})

export const createRepository = (repositoryFactory, httpClientInstanceIdentifier = 'proxy') => {
  let httpClientInstance = null
  if (httpClientInstanceIdentifier === 'proxy') {
    httpClientInstance = smwProxyInstance
  } else {
    throw new Error(`Provided httpClientInstanceIdentifier: ${httpClientInstanceIdentifier} is not supported!`)
  }
  if (!repositoryFactory) {
    return httpClientInstance
  }
  return repositoryFactory(httpClientInstance)
}
